import "/Users/billykwok/Repositories/me/packages/site-astro/src/utils/sentry/client.ts";
import { init } from 'astro/virtual-modules/prefetch.js';init()